import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import RelationalField from "./RelationalField";
import { forwardsManyToOneDescriptor, backwardsManyToOneDescriptor } from "../descriptors";
/**
 * @memberof module:fields
 */

export var ForeignKey =
/*#__PURE__*/
function (_RelationalField) {
  _inheritsLoose(ForeignKey, _RelationalField);

  function ForeignKey() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _RelationalField.call.apply(_RelationalField, [this].concat(args)) || this;
    _this.index = true;
    return _this;
  }

  var _proto = ForeignKey.prototype;

  _proto.createForwardsDescriptor = function createForwardsDescriptor(fieldName, model, toModel, throughModel) {
    return forwardsManyToOneDescriptor(fieldName, toModel.modelName);
  };

  _proto.createBackwardsDescriptor = function createBackwardsDescriptor(fieldName, model, toModel, throughModel) {
    return backwardsManyToOneDescriptor(fieldName, model.modelName);
  };

  return ForeignKey;
}(RelationalField);
export default ForeignKey;